// cafe/client/src/utils/videoUtils.js

/**
 * Genera una miniatura como un objeto File a partir de un objeto File de video.
 * @param {File} file - El archivo de video.
 * @param {number} seekTo - El segundo del video del cual extraer el fotograma.
 * @returns {Promise<File>} Una promesa que resuelve con un objeto File de la imagen en formato JPEG.
 */
export const generateVideoThumbnailFromFile = (file, seekTo = 1.0) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('video/')) {
      return reject(new Error('El archivo proporcionado no es un video.'));
    }

    const videoPlayer = document.createElement('video');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    videoPlayer.src = URL.createObjectURL(file);
    videoPlayer.muted = true;
    videoPlayer.playsInline = true;

    videoPlayer.onloadedmetadata = () => {
      videoPlayer.currentTime = seekTo;
    };

    videoPlayer.onseeked = () => {
      setTimeout(() => {
        canvas.width = videoPlayer.videoWidth;
        canvas.height = videoPlayer.videoHeight;
        context.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(videoPlayer.src);

        // Convertir el canvas a Blob y luego a File
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return reject(new Error('No se pudo crear el blob del canvas.'));
            }
            const thumbnailFile = new File([blob], 'thumbnail.jpg', {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(thumbnailFile);
          },
          'image/jpeg',
          0.85 // Calidad 85%
        );
      }, 200);
    };

    videoPlayer.onerror = (err) => {
      console.error('Error al cargar el video:', err);
      URL.revokeObjectURL(videoPlayer.src);
      reject(new Error('Error al cargar el video para generar la miniatura.'));
    };

    videoPlayer.load();
  });
};
